// extracted by mini-css-extract-plugin
module.exports = {"main":"comachi-layout-module--main--253hM"};